/* eslint-disable react/jsx-boolean-value */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import ModalWrapper from 'components/Modals/ModalWrapper';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';

class AssignToUserModalForm extends Component {
  static defaultProps = {
    formsList: [],

  };

  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirmAssign: PropTypes.func.isRequired,
    formsList: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);

    this.state = {
      formErrors: null,
      assignToUser: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onFormSubmit = (event) => {
    this.handleSubmit(event);
  }

  onAssignToUserSelectedItem = (lookupValue) => {
    this.setState({ assignToUser: lookupValue });
  }

  onAssignToUserChange = (e, value) => {
    const { assignToUser } = this.state;

    if (value === '') {
      this.setState({ assignToUser: null });
    }

    if (assignToUser && assignToUser.value !== value) {
      this.setState({ assignToUser: null });
    }
  }

  fieldHasErrors(field) {
    const { formErrors } = this.state;
    return formErrors != null && formErrors.filter(error => error.field === field).length > 0;
  }

  cancelAssign() {
    const { onCancel } = this.props;

    if (onCancel !== null) {
      this.setState({ assignToUser: null });
      onCancel();
    }
  }

  handleSubmit(event) {
    const {
      formsList,
      onConfirmAssign
    } = this.props;

    const {
      assignToUser
    } = this.state;

    event.preventDefault();

    if (!formsList || formsList.length === 0) {
      toastr.error('', 'Please close the window and try again');
      return;
    }

    onConfirmAssign(formsList, assignToUser);
    this.setState({ assignToUser: null });
  }

  render() {
    const { isShown } = this.props;
    const { assignToUser } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Assign To User"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ () => this.cancelAssign() }
        formId="assignToUserForm"
        modalSize="assign-to-user-modal"
        useDummySubmit={ true }
      >
        <div className="assign-to-user-modal">
          <form className="form-horizontal" id="assignToUserForm" name="assignToUserForm" onSubmit={ this.handleSubmit }>
            <div className="form-group">
              <div className="col-4">
                <label
                  htmlFor="legal-entity-id"
                  className="form-label m-2 text-right"
                >
                  User Account
                </label>
              </div>
              <div className="col-8">
                <AutoCompleteInput
                  id="assigned-user"
                  name="assignToUser"
                  category="user"
                  placeholder="Enter user name..."
                  value={ assignToUser || '' }
                  onSelectedItem={ lookupValue => this.onAssignToUserSelectedItem(lookupValue) }
                  onChange={ (e, value) => this.onAssignToUserChange(e, value) }
                />
              </div>
            </div>
            <button
              type="submit"
              id="dummy-add-form-btn"
              className="none"
            >Confirm
            </button>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  if (state.auth && state.auth.settings) {
    if (state.forms != null && state.forms.formsList != null && state.forms.formsList.length > 0) {
      const { formsList } = state.forms;
      return {
        formsList
      };
    }
  }
  return {};
};

const AssignToUserModalReduxForm = reduxForm({
  form: 'AssignToUserModalForm'
})(AssignToUserModalForm);

export const AssignToUserModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignToUserModalReduxForm);

export default AssignToUserModal;
